import { Component } from '@angular/core';

@Component({
    selector: 'right-panel-footer',
    template: '<ng-content />',
    styleUrls: ['./right-panel-footer.component.scss'],
    standalone: false
})
export class RightPanelFooterComponent {
}
